import { useEffect, useState } from 'react';
import { JOB_STATUS_COLORS_CHANGED_EVENT } from '../utils/jobStatusColors';

/**
 * Bumps when job status colors change in localStorage (Settings or other tabs).
 * Use in useMemo deps for grids/filters that cache status chip styles.
 */
export function useJobStatusColorsRevision() {
  const [revision, setRevision] = useState(0);

  useEffect(() => {
    const onChange = () => setRevision((r) => r + 1);
    window.addEventListener(JOB_STATUS_COLORS_CHANGED_EVENT, onChange);
    return () => window.removeEventListener(JOB_STATUS_COLORS_CHANGED_EVENT, onChange);
  }, []);

  return revision;
}
